import { makeAutoObservable } from 'mobx'
import { SelectType } from './models'

type AccountDocsType = {
	AVN_date: Date
	akadem_document_type: string
	document_date: string
	document_numer: string
	document_reg_numer: string
	id_akadem_document: number
	id_akadem_document_type: number
	id_avn_user: number
	id_student: number
	s_fio: string
}

type DocsType = {
	akadem_document_type: string
	id_akadem_document_type: number
}

class AccountDocs {
	docs: AccountDocsType[] = []
	docsType: SelectType[] = []

	constructor() {
		makeAutoObservable(this)
	}

	newDocs(param: AccountDocsType[]) {
		this.docs = param
	}

	newDocsType(param: SelectType[]) {
		this.docsType = param
	}
}

export const accountDocs = new AccountDocs()
